module.exports = __webpack_public_path__ + "static/media/lettucerice.ef97fbfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/base/lettucerice.jpg
// module id = 99
// module chunks = 0